<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        sm="4"
      >
        <div
          fluid
          style="height:20px;"
          class="mb-4 pt-0"
        >
          <v-btn
            v-if="selected.length > 0"
            color="primary"
            small
            class="mb-4 pt-0"
            @click="dialog = true"
          >
            Request Access
          </v-btn>
        </div>
      </v-col>
      <v-col
        class="caption text-right"
        cols="12"
        sm="8"
      >
        Retailer Missing? Send us a note at
        <a href="mailto:support@upperquadrant.com">support@upperquadrant.com</a>
      </v-col>
    </v-row>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items-per-page="10"
      :items="retailers"
      class="elevation-1 ml-1 mt-2"
      show-select
      item-key="accountId"
    >
      <template #[`item.status`]="{ item }">
        <v-chip
          color="grey"
          dark
          small
        >
          {{ item.status ? item.status : 'Not Connected' }}
        </v-chip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          Retailer Data Request
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-textarea
              v-model="note"
              outlined
              label="Personal Note"
            />
            <div class="caption">
              Optionally write a personal note that We'll include the retailer when sending the
              request. The following retailers will be invited.
              <ul>
                <li
                  v-for="item in selected"
                  :key="item.accountId"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="createConnections"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import connections from '../_api/connections';

export default {
  name: 'AvailableRetailers',
  props: {
    retailers: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      note: '',
      tab: null,
      selected: [],
      headers: [
        {
          text: 'Retailer',
          value: 'name',
          width: '60%',
        },
        {
          text: 'Status',
          value: 'status',
          align: 'center',
          width: '40%',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'getActiveAccount',
    ]),
  },
  methods: {
    async createConnections() {
      const accounts = this.selected.map((account) => account.accountId);
      await connections.createBrandConnections(this.getActiveAccount.id, accounts, this.note);
      this.selected = [];
      this.note = '';
      this.dialog = false;
      this.$emit('DataChange');
    },
  },
};
</script>
